/*
Copyright © SITA INC Ireland, SITA INC USA, SITA Switzerland Sarl 2025. Confidential. All rights reserved.
*/
import { Component } from '@angular/core';

@Component({
  selector: 'sita-privacy-policy',
  standalone: false,
  templateUrl: './privacy-policy.component.html',
  styleUrl: './privacy-policy.component.scss'
})
export class PrivacyPolicyComponent {

}
